import { createSlice } from "@reduxjs/toolkit";
import { BaseIntegrationRecordItem } from "./integrationRecord.model";

const initialState = {
  selectionRecord: {recordTab: 0, recordData: null}
};

export const workAssignmentSelectRecordSlice = createSlice({
  name: "recordAssignSelecting",
  initialState,
  reducers: {
    selectingRecord: (state, action) => {
      state.selectionRecord = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { selectingRecord } = workAssignmentSelectRecordSlice.actions;

export default workAssignmentSelectRecordSlice.reducer;
